<template>
  <FlexLayout
    v-if="consentFormLength"
    v-loading="loading.signRecordDetail"
    col
    :gap="8"
    class="card-container p-[20px]"
    style="padding-left: 30px"
  >
    <p class="section-title">
      簽名紀錄
    </p>
    <!-- <p class="sub-title"> 預約服務包含 {{ consentFormLength }} 份同意書，如需調整，請至「簽名紀錄同意書設定/預約」中進行編輯。</p> -->
    <transition name="el-fade-in-linear">
      <AppointmentConsentForm :details="context.signRecordDetail" />
    </transition>
  </FlexLayout>
</template>

<script>
import { appointmentModeType, useCreateAppointment } from '@/use/useCreateAppointment'
import { computed, defineComponent, watch, onUnmounted } from 'vue'
import AppointmentConsentForm from './AppointmentConsentForm.vue'
import FlexLayout from '@/components/FlexLayout.vue'
import { get, map, first } from 'lodash'
import { GetSignatureRecordCreationInfo } from '@/api/signatureTemplate'
import { useShop } from '@/use/shop'

export default defineComponent({
  name: 'AppointmentSignedNameBlock',
  components: { AppointmentConsentForm, FlexLayout },
  setup () {
    const { shopId } = useShop()
    const { context, cart, loading } = useCreateAppointment()

    const consentFormLength = computed(() => get(context.signRecordDetail, 'length', 0))

    // 簽名同意書
    let signRecordSeq = 0
    const refreshSignatureRecordCreationInfo = async () => {
      const seq = ++signRecordSeq
      loading.signRecordDetail = true

      const orders = []
      let effectiveAt

      if (context.appointmentMode === appointmentModeType.normal) {
        const cartItem = get(cart.value, '[0].cartItem')
        effectiveAt = get(cartItem, 'time')
        const reservation = cartItem ? cartItem.formatReservationsPayload(context) : []
        orders.push({
          reservations: map(reservation, (item) => {
            return {
              appointmentServiceId: item.appointmentServiceId,
              appointmentSubServiceId: item.appointmentSubServiceId,
              appointmentServiceAttachIds: item.appointmentServiceAttachIds,
            }
          }),
        })
      } else if (context.appointmentMode === appointmentModeType.otherReservation) {
        effectiveAt = get(first(cart.value), 'cartItem.time')
        const reservations = []
        for (const idx in cart.value) {
          const cartItem = get(cart.value, `[${idx}].cartItem`)
          const reservation = cartItem ? cartItem.formatReservationsPayload(context) : []

          const formatedReservation = map(reservation, (item) => {
            return {
              appointmentServiceId: item.appointmentServiceId,
              appointmentSubServiceId: item.appointmentSubServiceId,
              appointmentServiceAttachIds: item.appointmentServiceAttachIds,
            }
          })

          reservations.push(...formatedReservation)
        }
        orders.push({
          reservations,
        })
      } else if (context.appointmentMode === appointmentModeType.batchOrder) {
        effectiveAt = get(first(cart.value), 'cartItem.time')
        const reservations = []
        for (const idx in cart.value) {
          const cartItem = get(cart.value, `[${idx}].cartItem`)
          const reservation = cartItem ? cartItem.formatReservationsPayload(context) : []

          const formatedReservation = map(reservation, (item) => {
            return {
              appointmentServiceId: item.appointmentServiceId,
              appointmentSubServiceId: item.appointmentSubServiceId,
              appointmentServiceAttachIds: item.appointmentServiceAttachIds,
            }
          })

          reservations.push(...formatedReservation)
          orders.push({
            reservations,
          })
        }
      }

      const [res, errMsg] = await GetSignatureRecordCreationInfo({
        shopId: shopId.value,
        orders,
        effectiveAt,
        memberId: get(context, 'member.id'),
      })
      if (seq !== signRecordSeq) {
        loading.signRecordDetail = false
        return // 丟棄過期回應（快速切換會員時的競態防護）
      }
      loading.signRecordDetail = false
      if (errMsg) {
        window.$message.error(errMsg)
        return
      }

      context.signRecordDetail = get(res, 'signatureList') ?? null
    }

    // 初始載入及切換會員時重新取得簽名紀錄
    watch(() => get(context, 'member.id'), (newId) => {
      if (newId) {
        refreshSignatureRecordCreationInfo()
      } else {
        // 使所有進行中的請求失效，防止清除會員後飛行中的請求將舊簽名資料寫回 context
        signRecordSeq++
        loading.signRecordDetail = false
      }
    }, { immediate: true })

    // 元件銷毀時使所有進行中的請求失效（context 為全域 state，需防止 unmount 後飛行中請求寫回舊資料）
    onUnmounted(() => {
      signRecordSeq++
      loading.signRecordDetail = false
    })

    return { consentFormLength, context, loading }
  },
})
</script>

<style lang="postcss" scoped>
.section-title {
  @apply font-bold text-primary-100 text-[18px];
}
.sub-title {
  @apply text-gray-100 text-[12px];
}
</style>
